import FormSubmissionFailure from './FormSubmissionFailure';

export default FormSubmissionFailure;
